import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { AccountFacade } from '@edgvr-front/account/data-access';
import { LatestBinariesSelectors } from '@edgvr-front/binaries/data-access';
import { BinaryInstances } from '@edgvr-front/binaries/domain';
import { CompanyUrlService } from '@edgvr-front/companies/util/company-url';
import { Env, ENV_TOKEN } from '@edgvr-front/edgvr-portal/feature/env';
import { select, Store } from '@ngrx/store';
import { map } from 'rxjs';

@Component({
  selector: 'edgvr-front-portal-feature-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  readonly latest$ = this.store.pipe(select(LatestBinariesSelectors.latest));
  readonly installer$ = this.latest$.pipe(
    map((_) => _.find((_) => _.value.instance === BinaryInstances.Installer))
  );
  readonly moduleBuilder$ = this.latest$.pipe(
    map((_) =>
      _.find((_) => _.value.instance === BinaryInstances.ModuleBuilder)
    )
  );

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    @Inject(ENV_TOKEN) private readonly env: Env,
    private readonly accountFacade: AccountFacade,
    private readonly companyUrlService: CompanyUrlService,
    private readonly store: Store
  ) {}

  get company() {
    return this.companyUrlService.companyName(
      this.document.location.toString()
    );
  }

  get installerFile$() {
    return this.installer$.pipe(map((_) => _?.value.file));
  }

  get moduleBuilderFile$() {
    return this.moduleBuilder$.pipe(map((_) => _?.value.file));
  }

  get frontUrl() {
    return this.env.frontUrl;
  }

  get contact() {
    return this.env.contact;
  }

  onSignOut() {
    return this.accountFacade.signOut();
  }
}
